module.exports = global["$"] = require("-!/data/app/rdc-next/node_modules/source-map-loader/index.js!/data/app/rdc-next/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/expose-loader?$!/data/app/rdc-next/~/source-map-loader!/data/app/rdc-next/~/jquery/dist/jquery.js
// module id = 1231
// module chunks = 48 51